import React from 'react'
import { Accordion, AccordionTab } from 'primereact/accordion';

const Skills = () => {

	const header = (name, date, place) => {
		return (
			<div className="accordion-header">
				<p>{name}</p>
				<div className="right-section">
					<p>{date}</p>
					<p id="place">{place}</p>
				</div>
			</div>
		)
	}

	return (
		<div className="work-experience p-card">
			<Accordion multiple activeIndex={[0,1,2]}>
				<AccordionTab header={header('Technical')}>
					<div className="content">
		                                <p id="title">Accustomed:</p>
						<p> Kubernetes, GitLab + CI/CD, FluxCD, Puppet, Debian, Bash, Python, Jira/Confluence, Web-servers, Databases, Networking</p>
						<p id="title">Familiar:</p>
						<p> AWS, Terraform, Ansible, Prometheus/Grafana, Elastic Stack (ELK), Nagios/Icinga, Ceph, Ganeti, Proxmox, Red Hat/Rocky, Opnsense, Windows Server 2016/2019, Vagrant, Solarwinds</p>
					</div>
				</AccordionTab>
				<AccordionTab header={header('Languages')}>
					<div className="content">
						<p> Greek (Native), English (C2 - Cambridge Proficiency in English)</p>
					</div>
				</AccordionTab>
				<AccordionTab header={header('Soft')}>
					<div className="content">
						<p> Self-motivated, Efficient, Consistent, Organizational, Analytical, Social, Adaptive, Trustworthy, Effective on an individual and group level</p>
					</div>
				</AccordionTab>
			</Accordion>
		</div>
	)
}

export default Skills
